<template>
  <b-modal
    centered
    scrollable
    size="lg"
    :id="id"
    :title="$t('dharma-application-form.applicant.title')"
    @hidden="clearFormData"
  >
    <b-form id="form" autocomplete="on">
      <b-form-group :label="$t('dharma-application-form.applicant.type-selector.label')" label-size="lg" label-for="type">
        <b-form-select id="type" v-model="type">
          <template #first>
            <b-form-select-option value="" disabled>
              {{ $t('dharma-application-form.applicant.type-selector.hint') }}
            </b-form-select-option>
          </template>
          <b-form-select-option value="individual">
            {{ $t('dharma-application-form.applicant.type-selector.option.individual.label') }}
          </b-form-select-option>
          <b-form-select-option value="group">
            {{ $t('dharma-application-form.applicant.type-selector.option.group.label') }}
          </b-form-select-option>
          <!-- <b-form-select-option value="proxy">
            {{ $t('dharma-application-form.applicant.type-selector.option.proxy.label') }}
          </b-form-select-option> -->
        </b-form-select>
      </b-form-group>
      <b-form-row v-if="Object.keys(validation_result).length > 0 && !validation_result.succeeded">
        <b-col class="text-danger">
          <p class="font-weight-bold">{{ validation_result.message }}</p>
        </b-col>
      </b-form-row>
      <individual-form
        ref="individual_form"
        :is_bulk_application="total_application_items > 500"
        v-if="type == 'individual'"
      ></individual-form>
      <group-form
        ref="group_form"
        :is_bulk_application="total_application_items > 500"
        v-if="type == 'group'"
      ></group-form>
      <proxy-form
        ref="proxy_form"
        :is_bulk_application="total_application_items > 500"
        v-if="type == 'proxy'"
      ></proxy-form>
    </b-form>
    <template #modal-footer="{ close }">
      <b-button
        class="w-50"
        variant="default"
        @click="cancel"
      >{{ $t('modal.button.cancel.label') }}</b-button>
      <b-button
        class="w-50"
        variant="success"
        @click="submit"
      >{{ $t('modal.button.submit.label') }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import { Validators, createFormValidation } from '@lemoncode/fonk'
import i18n from '@/plugins/i18n.js'
import IndividualForm from '../IndividualForm'
import GroupForm from '../GroupForm'
import ProxyForm from '../ProxyForm'

export default {
  i18n,
  name: 'applicant-information-modal',
  props: {
    id: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      type: '',
      validation_result: {},
    }
  },
  computed: {
    validation_schema() {
      return {
        field: {
          type: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.error-message.type.required'),
            },
          ],
        },
      };
    },
    total_application_items() {
      const items = JSON.parse(this.$localStorage.get('application-items', '[]'));
      return items.reduce((sum, item) => sum + parseInt(item.quantity), 0);
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
      this.$bvModal.hide(this.id)
    },
    async submit() {
      await this.validateForm();

      if (this.validation_result.succeeded) {
        const form = this.$refs[`${this.type}_form`]
        const form_validation_result = await form.validateForm()

        if (form_validation_result) {
          this.$emit('submit', {
            type: this.type,
            delivery: form.delivery,
            applicant: form.applicant,
          })

          this.$bvModal.hide(this.id)
        }
      }
    },
    async validateForm() {
      const validation = createFormValidation(this.validation_schema)
      await validation
        .validateField('type', this.type)
        .then(form_validation_result => {
          this.validation_result = form_validation_result;
        })
    },
    clearFormData() {
      this.type = '';
      this.validation_result = {};
    }
  },
  components: {
    IndividualForm,
    GroupForm,
    ProxyForm,
  }
};
</script>
